(function () {
  'use strict';

  function init(root) {
    if (root.bwbReady) return;
    root.bwbReady = true;

    var qs = function (sel) { return root.querySelector(sel); };
    var qsa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    /* Gallery */
    var track = qs('[data-bwb-track]');
    var slides = qsa('[data-bwb-slide]');
    var thumbs = qsa('[data-bwb-thumb]');
    var counter = qs('[data-bwb-count]');
    var active = 0;
    var locked = false;

    function stopMedia(slide) {
      if (!slide) return;
      var video = slide.querySelector('video');
      if (video && !video.paused) video.pause();
      var frame = slide.querySelector('iframe');
      var poster = slide.querySelector('[data-bwb-play]');
      if (frame && poster) {
        frame.parentNode.removeChild(frame);
        poster.hidden = false;
      }
    }

    function setActive(index) {
      if (index === active || !slides[index]) return;
      stopMedia(slides[active]);
      active = index;
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
      var thumb = thumbs[index];
      if (thumb) {
        var strip = thumb.parentNode;
        strip.scrollLeft = thumb.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2;
      }
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
    }

    function goTo(index, smooth) {
      if (!track || !slides[index]) return;
      locked = true;
      track.scrollTo({ left: index * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      setActive(index);
      setTimeout(function () { locked = false; }, 500);
    }

    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking || locked) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          if (track.clientWidth) setActive(Math.round(track.scrollLeft / track.clientWidth));
        });
      }, { passive: true });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i, true); });
    });

    qsa('[data-bwb-play]').forEach(function (poster) {
      poster.addEventListener('click', function () {
        var tpl = poster.parentNode.querySelector('template');
        if (!tpl) return;
        poster.parentNode.appendChild(tpl.content.cloneNode(true));
        poster.hidden = true;
      });
    });

    /* Quantity */
    var qtyInput = qs('.js-bwb-qty');

    function quantity() {
      return Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
    }

    function stepQuantity(delta) {
      if (qtyInput) qtyInput.value = Math.max(1, quantity() + delta);
    }

    var minus = qs('.js-bwb-minus');
    var plus = qs('.js-bwb-plus');
    if (minus) minus.addEventListener('click', function () { stepQuantity(-1); });
    if (plus) plus.addEventListener('click', function () { stepQuantity(1); });

    /* Variants */
    var idInput = qs('.js-bwb-variant-input');
    var addButton = qs('.js-bwb-add');
    var buyButtons = qsa('.js-bwb-buy');
    var errorBox = qs('[data-bwb-error]');
    var optionGroups = qsa('[data-bwb-options] fieldset');
    var dataEl = qs('[data-bwb-variants]');
    var variants = [];

    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variants = []; }

    if (!idInput) return;

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var match = variants[i].options.every(function (value, n) { return value === options[n]; });
        if (match) return variants[i];
      }
      return null;
    }

    function setText(selector, text, show) {
      qsa(selector).forEach(function (el) {
        el.textContent = text || '';
        if (typeof show === 'boolean') el.hidden = !show;
      });
    }

    function renderVariant(variant) {
      var available = !!(variant && variant.available);

      if (variant) {
        idInput.value = variant.id;
        setText('[data-bwb-price-now]', variant.price);
        setText('[data-bwb-price-compare]', variant.compare, !!variant.compare);
        setText('[data-bwb-price-off]', variant.save, !!variant.save);

        if (variant.media) {
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].getAttribute('data-media-id') === String(variant.media)) {
              if (i !== active) goTo(i, true);
              break;
            }
          }
        }

        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState(history.state, '', url.toString());
        }
      }

      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available
          ? addButton.getAttribute('data-label')
          : root.getAttribute(variant ? 'data-sold-out' : 'data-unavailable');
      }

      buyButtons.forEach(function (button) {
        button.disabled = !available;
        if (button.hasAttribute('data-bwb-hide-out')) button.hidden = !available;
      });

      var stock = qs('[data-bwb-stock]');
      if (stock) {
        stock.classList.toggle('is-out', !available);
        setText('[data-bwb-stock-text]', root.getAttribute(available ? 'data-in-stock' : 'data-out-of-stock'));
      }
    }

    function markOptions(options) {
      optionGroups.forEach(function (group, index) {
        Array.prototype.forEach.call(group.querySelectorAll('input'), function (input) {
          var test = options.slice();
          test[index] = input.value;
          var variant = findVariant(test);
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !(variant && variant.available));
        });
        var current = group.querySelector('[data-bwb-option-value]');
        if (current) current.textContent = options[index] || '';
      });
    }

    optionGroups.forEach(function (group) {
      group.addEventListener('change', function () {
        var options = selectedOptions();
        markOptions(options);
        renderVariant(findVariant(options));
        showError('');
      });
    });

    if (optionGroups.length) {
      var initialOptions = selectedOptions();
      markOptions(initialOptions);
      var initialVariant = findVariant(initialOptions);
      if (initialVariant && initialVariant.media) {
        for (var s = 0; s < slides.length; s++) {
          if (slides[s].getAttribute('data-media-id') === String(initialVariant.media) && s !== 0) {
            goTo(s, false);
            break;
          }
        }
      }
    }

    /* Cart */
    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message || '';
      errorBox.hidden = !message;
    }

    function addToCart() {
      var id = parseInt(idInput.value, 10);
      if (!id) return Promise.reject(new Error(root.getAttribute('data-unavailable')));

      return fetch(root.getAttribute('data-cart-add-url') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: id, quantity: quantity() }] })
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || root.getAttribute('data-error'));
          return data;
        });
      });
    }

    function openCartDrawer() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      setTimeout(function () {
        var trigger =
          document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]') ||
          document.querySelector('[data-drawer-id="sidebar-cart"]');

        if (trigger) trigger.click();
        else window.location.href = root.getAttribute('data-cart-url');
      }, 350);
    }

    function run(button, busyText, onSuccess) {
      if (!button || button.disabled) return;
      var label = button.textContent;
      button.disabled = true;
      button.textContent = busyText;
      showError('');

      addToCart()
        .then(onSuccess)
        .then(function (keepBusy) {
          if (keepBusy === true) return;
          button.disabled = false;
          button.textContent = label;
        })
        .catch(function (error) {
          showError(error && error.message ? error.message : root.getAttribute('data-error'));
          button.disabled = false;
          button.textContent = label;
        });
    }

    if (addButton) {
      addButton.addEventListener('click', function (event) {
        event.preventDefault();
        run(addButton, root.getAttribute('data-adding'), openCartDrawer);
      });
    }

    buyButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        run(button, root.getAttribute('data-processing'), function () {
          window.location.href = root.getAttribute('data-checkout-url');
          return true;
        });
      });
    });

    /* Sticky purchase bar */
    var sticky = qs('[data-bwb-sticky]');
    var buttonsBlock = qs('[data-bwb-buttons]');

    if (sticky && buttonsBlock && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(buttonsBlock);
    }

    /* Related products, loaded when the block approaches the viewport */
    var related = qs('[data-bwb-related]');

    if (related && 'IntersectionObserver' in window) {
      var relatedObserver = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        relatedObserver.disconnect();

        fetch(related.getAttribute('data-url'))
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (html) {
            var box = document.createElement('div');
            box.innerHTML = html;
            var items = box.querySelector('[data-bwb-related-items]');
            if (!items || !items.children.length) return;
            related.querySelector('[data-bwb-related-list]').innerHTML = items.innerHTML;
            related.classList.add('is-loaded');
          })
          .catch(function () {});
      }, { rootMargin: '600px 0px' });

      relatedObserver.observe(related);
    }
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-bwb]'), init);
  }

  boot();
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
